import axios from "axios";
import {
  onRequest,
  onRequestError,
  onResponse,
  onResponseError,
} from "./interceptor";

export const API_BASE_URL = "/api"; // Fixed API URL
export const API_BASE_URL_SELL = '/portal';


export const baseApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: "application/json",
  },
});


export const baseApiSell = axios.create({
  baseURL: API_BASE_URL_SELL,
  headers: {
    Accept: 'application/json',
  },
  withCredentials: true, // Automatically sends cookies with requests
});


// Interceptors
baseApi.interceptors.request.use(onRequest, onRequestError);
baseApi.interceptors.response.use(onResponse, onResponseError);
